import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import './InstagramSliderProfileInfo.css';


function InstagramSliderProfileInfo(props) {
  const { item } = props;
  const { t } = useTranslation();

  return (
    <div className="instagram-slider-profile-info__component">
      <div className="profile">
        <div className="icon" />
        <div className="name">{item.instagram_username && item.instagram_username}</div>
      </div>
      <div className="verified">
        <div className="icon" />
        <div className="text">{t('Verified')}</div>
      </div>
    </div>
  );
}

InstagramSliderProfileInfo.propTypes = {
  item: PropTypes.object.isRequired,
};

export default InstagramSliderProfileInfo;
